export default {
  placeholder: 'Choose the tags',
  tagPlaceholder: 'Add new tag',
};
